/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.ReturnPage')
    .factory('ReturnPage', ['$cookieStore', function($cookieStore) {
        var
            GO_BACK_COOKIE_KEY = 'goBackTo';

        return {
            set: function(location) {
                $cookieStore.put(GO_BACK_COOKIE_KEY, location);
            },
            get: function () {
                var
                    location = $cookieStore.get(GO_BACK_COOKIE_KEY);

                $cookieStore.remove(GO_BACK_COOKIE_KEY);
                return location;
            }
        }
    }]);
